export default {
  rules: {
    productName: [
      { required: true, message: '请输入商品名称', trigger: 'blur' },
      { max: 100, message: '长度最大 100 个字符', trigger: 'blur' }
    ],
    productNameRemark: [
      { required: false, message: '请输入名称备注', trigger: 'blur' },
      { max: 100, message: '长度最大 100 个字符', trigger: 'blur' }
    ],
    productNumber: [
      { required: false, message: '请输入商品编号', trigger: 'blur' },
      { max: 30, message: '长度最大 30 个字符', trigger: 'blur' }
    ],
    categoryId: [
      { required: true, message: '请选择商品类型', trigger: 'change' }
    ],
    tradeType: [
      { required: true, message: '请选择贸易类型', trigger: 'change' }
    ],
    tagType: [{ required: true, message: '请选择标签类型', trigger: 'change' }],
    productImages: [
      {
        type: 'array',
        required: true,
        message: '请上传商品图片',
        trigger: 'change'
      }
    ]
  }
}
